// removed by extract-text-webpack-plugin
module.exports = {"content":"Consent__content__1qqkm","parentContainer":"Consent__parentContainer__1TN4e"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Consent/Consent.css
// module id = 3098
// module chunks = 0